import React from "react";
import { QueryClientProvider, QueryClient } from "react-query";
import { KitProvider, SnackbarProvider } from "@kitbird/core";
import Routers from "./routers/Routers";
import AuthProvider from "./components/Authentication/AuthProvider";
import GlobalProvider from "./components/Global/GlobalProvider";
import "./App.css";

function App() {
  const queryClient = new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: false,
      },
    },
  });

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <GlobalProvider>
          <KitProvider color="bluebird" >
            <SnackbarProvider>
              <Routers />
            </SnackbarProvider>
          </KitProvider>
        </GlobalProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;
